<template>
  <div>
    <div class="infoListBox">
      <div v-for="item in items" :key="item.ID" class="infoItem clearfix" v-on:click="showDetail(item.ID)">
        <div class="fl imgBox">
          <img :key="item.Att.AttID" :src="item.Att.Url" alt/>
        </div>
        <div class="fl infoBox">
          <div class="title">{{item.Title}}</div>
          <div class="desc" v-html="item.Content"></div>
          <div class="date">{{item.PublishTime}}</div>
        </div>
      </div>
    </div>
    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination
        @current-change="loadMore"
        background
        :page-size="search.PageSize"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../../api";
export default {
  data() {
    return {
      showLoading: false,
      items: [],
      total: 0,
      search: {
        PageNo: 1,
        PageSize: 20,
        typeId: 1
      }
    };
  },
  methods: {
    showDetail(id) {
      this.$router.push("/news/detail?id=" + id);
    },
    loadMore(n) {
      this.search.PageNo = n;
      this.loadItems();
    },
    reload() {
      this.search.PageNo = 1;
      this.loadItems();
    },
    loadItems() {
      let _this = this;
      _this.showLoading = true;
      api.searchNews(_this.search).then(res => {
        _this.showLoading = false;
        if (res.data.Succeed) {
          _this.items = res.data.Data.Data;
          _this.total = res.data.Data.totalItemCount;
          for(var item in _this.items){
            _this.items[item].Att.Url=process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+_this.items[item].Att.AttID
          }
        }
      });
    }
  },
  mounted() {
    this.loadItems();
  }
};
</script>
<style>
.infoListBox {
  width: 1200px;
  margin: -10px auto 40px;
}
.infoListBox {
  width: 1200px;
  margin: -10px auto 40px;
}
.infoListBox .infoItem {
  padding-bottom: 20px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 18px;
}
.infoListBox .infoItem .imgBox {
  width: 220px;
  height: 140px;
  overflow: hidden;
  margin-right: 20px;
  float: left;
}
.infoListBox .infoItem .infoBox {
  width: 950px;
}
.infoListBox .infoItem .infoBox .title {
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 15px;
}
.infoListBox .infoItem .infoBox .desc {
  font-size: 16px;
  line-height: 28px;
  color: #999999;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 84px;
}
.infoListBox .infoItem .infoBox .date {
  font-size: 14px;
  line-height: 14px;
  color: #999999;
}
.imgBox img {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/MessageCenter/NewsList.vue